import React from "react";
import { Link } from "react-router-dom";
import pageNotFoundImage from "../assets/images/page-not-found.jpg";

const PageNotFound = () => {
  return (
    <div className="container d-flex flex-column align-items-center justify-content-center vh-50 text-center">
      <div className="w-50 h-50">
        <img
          src={pageNotFoundImage}
          alt="Page Not Found"
          className="img-fluid"
        />
      </div>
      <div className="mt-4 mb-2">
        <Link to="/" className="btn orange-btn text-white">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
